type TransactionError = {
  code: "CALL_EXCEPTION" | "INSUFFICIENT_FUNDS"
  error: string
  message: string
}

export function extractErrorMessage(something: unknown, fallback = "Error") {
  if (!something) {
    return fallback
  }
  if (typeof something === "string") {
    return something
  }
  if (typeof something === "object") {
    const error = something as TransactionError

    if (error.code === "INSUFFICIENT_FUNDS") {
      return "Account does not have enough funds to cover the cost of the transaction"
    }

    return error.message
  }
  return fallback
}
